import { NgModule, ModuleWithProviders, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { FooterComponent } from 'src/app/pages/layout/footer/footer.component';
import { LeftSideMenuComponent } from 'src/app/pages/layout/left-side-menu/left-side-menu/left-side-menu.component';
import { CountryFlagPhoneDirective } from './country-flag-phone/country-flag-phone.directive';
import { AllowValuesDirective } from './allow-values/allow-values.directive';
// import { LiveChatComponent } from 'src/app/pages/layout/live-chat/live-chat/live-chat.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { PasswordStrengthComponent } from './password-strength/password-strength.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatRadioModule } from '@angular/material/radio';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { PickerModule } from '@ctrl/ngx-emoji-mart';
import { PipeModule } from 'src/app/core/pipes/pipe.module';
import { EmojiModule } from '@ctrl/ngx-emoji-mart/ngx-emoji';
import { ContentLoadingComponent } from './content-loading/content-loading.component';
// import { PaymentComponent } from 'src/app/pages/components/general/payment/payment.component';
import { WebsiteFooterComponent } from 'src/app/pages/components/website/layout/website-footer/website-footer.component';
import { SubscribePaymentComponent } from 'src/app/pages/components/general/subscribe-payment/subscribe-payment.component';
import { CountDownTimerComponent } from './count-down-timer/count-down-timer/count-down-timer.component';
import {DirectiveSvgComponent} from './directive-svg/directive-svg.component';
import { MarkdownModule } from "ngx-markdown";
import { HideBrokenImgDirective } from './hide-broken-img/hide-broken-img.directive';
const Directives = [
  // FooterComponent,
  LeftSideMenuComponent,
  // LiveChatComponent,
  CountryFlagPhoneDirective,
  AllowValuesDirective,
  PasswordStrengthComponent,
  ContentLoadingComponent,
  // PaymentComponent,
  //WebsiteFooterComponent,
  //SubscribePaymentComponent,
  CountDownTimerComponent,
  DirectiveSvgComponent,
  HideBrokenImgDirective
];
@NgModule({
  declarations: [...Directives],
  exports: [...Directives,
  ],
  imports: [
    CommonModule,
    RouterModule,
    MatButtonModule,
    MatIconModule,
    FlexLayoutModule,
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    PickerModule,
    MatTooltipModule,
    PipeModule,
    MarkdownModule,
    EmojiModule,
    MatProgressBarModule,
    MatCheckboxModule,
    MatAutocompleteModule,
    MatRadioModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class DirectivesModule {
  static forRoot(): ModuleWithProviders<DirectivesModule>{
    return{
      ngModule: DirectivesModule,
    };
  }
}
